import apiClient from '../axios.js';

/**
 * 數據分析 API
 */
export const analyticsService = {
  /**
   * 取得 RFM 分析結果
   */
  getRfmAnalysis: async (params = {}) => {
    const response = await apiClient.get('/analytics/rfm', { params });
    return response;
  },

  /**
   * 取得 RFM Dashboard 統計
   */
  getRfmDashboard: async (params = {}) => {
    const response = await apiClient.get('/analytics/rfm/dashboard', { params });
    return response;
  },

  /**
   * 取得會員 CLV
   */
  getMemberClv: async (memberId) => {
    const response = await apiClient.get(`/analytics/clv/${memberId}`);
    return response;
  },

  /**
   * 取得 CLV 排行榜
   */
  getClvRanking: async (params = {}) => {
    const response = await apiClient.get('/analytics/clv/ranking', { params });
    return response;
  },

  /**
   * 取得流失預警會員
   */
  getChurnMembers: async (params = {}) => {
    const response = await apiClient.get('/analytics/churn', { params });
    return response;
  },

  /**
   * 取得流失率統計
   */
  getChurnStatistics: async () => {
    const response = await apiClient.get('/analytics/churn/statistics');
    return response;
  },

  /**
   * 取得月活躍用戶數
   */
  getMAU: async (params = {}) => {
    const response = await apiClient.get('/analytics/activity/mau', { params });
    return response;
  },

  /**
   * 取得日活躍用戶數
   */
  getDAU: async (params = {}) => {
    const response = await apiClient.get('/analytics/activity/dau', { params });
    return response;
  },

  /**
   * 取得活躍率
   */
  getActivityRate: async (params = {}) => {
    const response = await apiClient.get('/analytics/activity/rate', { params });
    return response;
  },

  /**
   * 取得活躍度趨勢
   */
  getActivityTrend: async (params = {}) => {
    const response = await apiClient.get('/analytics/activity/trend', { params });
    return response;
  },

  /**
   * 取得 Dashboard KPI
   */
  getDashboardKpi: async (params = {}) => {
    const response = await apiClient.get('/analytics/dashboard/kpi', { params });
    return response;
  },

  /**
   * 手動觸發 RFM 計算
   */
  triggerRfmCalculation: async () => {
    const response = await apiClient.post('/analytics/rfm/calculate');
    return response;
  },

  /**
   * 手動觸發 CLV 計算
   */
  triggerClvCalculation: async () => {
    const response = await apiClient.post('/analytics/clv/calculate');
    return response;
  }
};
